import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tmw-time-edit',
  standalone: true,
  imports: [],
  templateUrl: './time-edit.component.html',
  styleUrl: './time-edit.component.scss',
})
export class TmwTimeEditComponent {
  _value: any;

  @Output() valueChange = new EventEmitter();
  @Input() set value(val: any) {
    this._value = val;
  }
}
